import config from '@/config';
import useCache from '@/hooks/useCache';
import useTranslations from '@/i18n/useTranslations';
import Loader from '@/shared-components/loader/Loader';
import ActivityHeading from '@/shared-components/text/components/ActivityHeading';
import Text from '@/shared-components/text/components/Text';
import { filterRenderableArtlists } from '@/utils/activityContent';

import VirtualList from './components/VirtualList';

import './index.css';

export default function LikedArtlists() {
  const t = useTranslations('common.profile.activity');
  const { loading, fetchData, loadMoreData } = useCache("liked_artlists", `${config.apis.api.url}/artlists/liked`, {
    injectToken: true,
    invalidateWhen: ["LIKE_ARTLIST"]
  });
  const safeFetchData = fetchData ?? { data: [], totalDocs: 0 };
  const visibleArtlists = filterRenderableArtlists(safeFetchData.data);

  return (
    <>
      <ActivityHeading text={t('menu.liked_artlists')}/>
      <div className="activity-liked-artlists__container">
        {
          loading ? 
            <Loader />
            : visibleArtlists.length === 0 ? 
              <Text className="activity-liked-artlists__text font-size-medium">
                {t('empty.liked_artlists')}
              </Text>
              :
              <VirtualList items={safeFetchData} visibleItems={visibleArtlists} onLoadMore={loadMoreData}/>
        }
      </div>
    </>
  );
}
